import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
const mergeClasses = extendTailwindMerge({ prefix: "tw-" });
export function cn(...inputs) {
  return mergeClasses(clsx(inputs));
}
